export const TagColorMapping = {
  Harmful: "#FF655B",
  Valuable: "#BF87D6",
  Sensitive: "#3F466D",
};
